import moment from 'moment'
import { formatIncompletePhoneNumber, parseIncompletePhoneNumber } from 'libphonenumber-js'
import { intl } from 'utils'
import messages from './messages'

console.log(messages)
export function requiredRule(item, isMsg) {
  return {
    rules: [
      {
        required: true,
        message: isMsg ? item : intl.formatMessage(messages.requiredRule, { item })
      }
    ]
  }
}
export function nameRule(item = intl.formatMessage(messages.formItemName)) {
  return {
    validateTrigger: 'onBlur',
    rules: [
      {
        required: true,
        pattern: /^[a-zA-Z ]{2,50}$/,
        message: intl.formatMessage(messages.validRule, { item }),
      },
    ],
  }
}
export function cardNumberRule() {
  return {
    validateTrigger: 'onBlur',
    normalize: (value, prev) => {
      if (/^[0-9 ]*$/.test(value)) {
        return value
          ? value.replace(/ /g, '').match(new RegExp('.{1,4}', 'g')).join(' ')
          : value
      }
      return prev
    },
    rules: [
      {
        required: true,
        pattern: /^[0-9 ]{19,23}$/,
        message: intl.formatMessage(messages.validRule, {
          item: intl.formatMessage(messages.formItemCardNumber),
        }),
      },
    ],
  }
}
export function expireDateRule() {
  return {
    validateTrigger: 'onBlur',
    normalize: (value, prev) => {
      if (/^[0-9/]*$/.test(value)) {
        if (!value) {
          return value
        }
        if (value.length === 2 && Number(value) > 12) {
          return prev
        }
        return value
          .replace(/\//g, '')
          .match(new RegExp('.{1,2}', 'g'))
          .join('/')
      }
      return prev
    },
    rules: [
      {
        required: true,
        pattern: /^[0-9/]{5}$/,
        message: intl.formatMessage(messages.validRule, {
          item: intl.formatMessage(messages.formItemExpiryDate),
        }),
      },
      {
        validator: (rules, value, callback) => {
          // 判断录入有效期是否在当前时间下已过期
          const errors = []
          try {
            const [month, year] = value.split('/')
            const isExpired = moment(`${month}-${year}`, 'MM-YY')
              .endOf('month')
              .isBefore(new Date())
            if (isExpired) {
              errors.push(
                new Error(intl.formatMessage(messages.expireDateRule))
              )
            }
          } catch (error) {}
          callback(errors)
        },
      },
    ],
  }
}
export function securityCodeRule() {
  return {
    validateTrigger: 'onBlur',
    normalize: (value, prev) => {
      if (/^[0-9]*$/.test(value)) {
        return value
      }
      return prev
    },
    rules: [
      {
        required: true,
        pattern: /^[0-9]{3}$/,
        message: intl.formatMessage(messages.validRule, {
          item: intl.formatMessage(messages.formItemSecurityCode),
        }),
      },
    ],
  }
}
export function ibanRule() {
  return {
    validateTrigger: 'onBlur',
    normalize: (value, prev) => {
      return value ? value.toUpperCase() : value
    },
    rules: [
      {
        required: true,
        pattern: /^AE[0-9]{21}$/,
        message: intl.formatMessage(messages.validRule, {
          item: intl.formatMessage(messages.formItemIABNNumber),
        }),
      },
    ],
  }
}
export function mobileRule() {
  return {
    validateTrigger: 'onBlur',
    normalize: (value = '', prev = '') => {
      const country = 'AE'
      if (value.length === 1 && value !== '0') {
        // 首位补0
        return `0${value}`
      }
      if (value === prev) {
        return value
      }
      // 调用国际化组件按国家/地区的格式对输入手机号格式化
      if (
        parseIncompletePhoneNumber(value) === parseIncompletePhoneNumber(prev)
      ) {
        return parseIncompletePhoneNumber(value)
      }
      return formatIncompletePhoneNumber(value, country)
    },
    rules: [
      {
        required: true,
        len: 12,
        pattern: /^05[0-9 ]{10}$/,
        message: intl.formatMessage(messages.validRule, {
          item: intl.formatMessage(messages.formItemMobileNumber),
        }),
      },
    ],
  }
}
export function amountRule(item) {
  return {
    normalize: (value, prev) => {
      if (/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/.test(value) || value === '') {
        return value
      }
      return prev
    },
    rules: [
      {
        required: true,
        message: intl.formatMessage(messages.requiredRule, {
          item,
        }),
      },
    ],
  }
}
export function requiredArrayRule(item) {
  return {
    rules: [
      {
        required: true,
        type: 'array',
        min: 1,
        message: intl.formatMessage(messages.requiredRule, { item }),
      },
    ],
  }
}
export function emailRule(required) {
  return {
    rules: [
      {
        required: !!required,
        type: 'email',
        message: intl.formatMessage(messages.validRule, {
          item: intl.formatMessage(messages.formItemEmailAddress),
        }),
      },
    ],
  }
}
